/**
 *
 * Tooltip
 *
 */

import { Box, Tooltip as MuiTooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { Subtitle } from './Tooltip.styles';

const Tooltip = ({ children, ...props }) => {
  const { subtitle } = props;
  let { title } = props;

  if (subtitle) {
    title = (
      <Box>
        {title && <Box>{title}</Box>}
        <Subtitle component="div" variant="body3">
          {subtitle}
        </Subtitle>
      </Box>
    );
  }

  return (
    <MuiTooltip {...props} title={title}>
      {children}
    </MuiTooltip>
  );
};

Tooltip.propTypes = {
  arrow: PropTypes.bool,
  children: PropTypes.node,
  placement: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.node,
};

export default memo(Tooltip);

export { TooltipData } from './Tooltip.styles';
